import React, { useState } from "react";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import SerialStepForm from "../../components/register/SerialStepForm";
import GuideLink from "../../components/guides/GuideLink";
import { RegistrationDraftStore } from "../../store/store";
import { parseArtomeSerial } from "../../lib/serial";
import { paths } from "../paths";
import sernoImage from "../../images/X20/serial-no/x20-serial-no.png";

export default function ArtomeSerialStep() {
  const navigate = useNavigate();
  const setArtomeSerial = RegistrationDraftStore((s) => s.setArtomeSerial);
  const existing = RegistrationDraftStore((s) => s.artomeSerialNo);

  const [value, setValue] = useState(existing);
  const parsed = parseArtomeSerial(value);

  const handleSubmit = () => {
    if (!parsed.valid || !parsed.product) return;
    setArtomeSerial(parsed.normalized, parsed.product);
    navigate(paths.registerProjector);
  };

  return (
    <SerialStepForm
      label="Artome serial number"
      helperText="Printed on the label on the device. Case does not matter."
      image={sernoImage}
      imageAlt="Location of the Artome serial number label on the device"
      value={value}
      onChange={setValue}
      valid={parsed.valid}
      errorText="That does not look like an Artome serial number."
      onSubmit={handleSubmit}
      onBack={() => navigate(paths.home)}
    >
      {parsed.valid && parsed.product && (
        <Alert severity="success" sx={{ mt: 1, mb: 1 }}>
          Recognised as <strong>Artome {parsed.product}</strong>.{" "}
          <GuideLink product={parsed.product} />
        </Alert>
      )}
    </SerialStepForm>
  );
}
